// export const validateInput = (inputData, schema, schemaType, type = null) => {
//   let errors = {};
//   let status = true;
//   const keysToValidate = type ? [type] : Object.keys(schemaType[schema]);

//   keysToValidate.forEach((key) => {
//     const field = schemaType[schema][key];
//     const value = inputData[key];

//     if (
//       field.required &&
//       (value === undefined || value === "")
//       // ||
//       // (Array.isArray(value) && value.length === 0)
//     ) {
//       errors[key] = field?.message;
//       if (field.extraMessage) {
//         errors[`${key}Err`] = true;
//       }
//       status = false;
//     } else if (field.validate && !field.validate(value, inputData)) {
//       if (field.extraMessage) {
//         errors[`${key}Err`] = true;
//         errors[key] = field.invalidMessage;
//       }
//       status = false;
//     }
//   });
//   return { errors, status };
// };
import i18n from "i18next";

export const validateInput = (inputData, schema, schemaType, type = null) => {
  let errors = {};
  let status = true;
  const keysToValidate = type ? [type] : Object.keys(schemaType[schema]);

  const validateNested = (value, fieldSchema) => {
    if (Array.isArray(value)) {
      // Handle array validation for each element
      return value.every((item, index) => {
        const result = validateInput(item, schema, schemaType, fieldSchema);
        if (!result.status) {
          errors[`${fieldSchema}.${index}`] = result.errors;
        }
        return result.status;
      });
    } else if (typeof value === "object" && value !== null) {
      // Handle object validation
      return validateInput(value, schema, schemaType, fieldSchema);
    } else {
      // Handle simple value validation
      return validateInput({ [fieldSchema]: value }, schema, schemaType);
    }
  };

  keysToValidate.forEach((key) => {
    const field = schemaType[schema][key];
    const value = inputData[key];

    if (field.required && (value === undefined || value === "")) {
      errors[key] = i18n.t(`ERROR.${field?.message}`);
      if (field.extraMessage) {
        errors[`${key}Err`] = true;
      }
      status = false;
    } else if (field.validate && !field.validate(value, inputData)) {
      if (field.extraMessage) {
        errors[`${key}Err`] = true;
        errors[key] = i18n.t(`ERROR.${field.invalidMessage}`);
      }
      status = false;
    } else if (field.nested && !validateNested(value, key)) {
      status = false;
    }
  });

  return { errors, status };
};

export const removeErrorFields = (errorObject, fieldName) => {
  const updatedError = { ...errorObject };

  // Remove the specific field and its associated error
  if (updatedError[fieldName]) delete updatedError[fieldName];
  if (updatedError[`${fieldName}Err`]) delete updatedError[`${fieldName}Err`];

  return updatedError;
};
